import { modelRequest } from '@stem-sims/nexus'
import { CountriesResponse } from '../types/accountTypes'

export function get(): Promise<CountriesResponse> {
    return modelRequest.get("/api/countries")
}
